module.exports = __webpack_public_path__ + "img/unity3D.3d7c84d7.jpg";